<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12">
    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-12 p-0 m-0">
      <!-- Container: Container 4 -->
      <div class="rappider-container container-4 col-10 p-0 m-0">
        <!-- Container: Container 5 -->
        <div
          class="rappider-container container-5 col-12 hidden-mw480 p-0 navbar-1-height m-0"
        >
          <!-- Container: Container 6 -->
          <div
            class="rappider-container container-6 col-3 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Image 1 -->
              <rappider-image
                [source]="image_1.source"
                [alternateText]="image_1.alternateText"
                [placeholder]="image_1.placeholder"
                [disablePreview]="image_1.disablePreview"
                [borderSettings]="image_1.borderSettings"
                [shadowSettings]="image_1.shadowSettings"
                [paddingSettings]="image_1.paddingSettings"
                [marginSettings]="image_1.marginSettings"
                [customSizeSettings]="image_1.customSizeSettings"
              >
              </rappider-image>
            </div>
          </div>

          <!-- Container: Container 7 -->
          <div
            class="rappider-container container-7 col-6 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Dropdown Menu 2 -->
              <rappider-dropdown-menu
                [icon]="dropdownMenu_2.icon"
                [placement]="dropdownMenu_2.placement"
                [triggerType]="dropdownMenu_2.triggerType"
                [items]="dropdownMenu_2.items"
                [label]="dropdownMenu_2.label"
                [labelMode]="dropdownMenu_2.labelMode"
              >
              </rappider-dropdown-menu>
            </div>

            <div class="rappider-component select-height">
              <!-- Component: Select 3 -->
              <rappider-select
                [grouppedOptions]="select_3.grouppedOptions"
                [placeholder]="select_3.placeholder"
                [invalidConfigText]="select_3.invalidConfigText"
                [disabled]="select_3.disabled"
                [buttons]="select_3.buttons"
                [dropdownMatchSelectWidth]="select_3.dropdownMatchSelectWidth"
                [dropdownClassName]="select_3.dropdownClassName"
                [cssStyle]="select_3.cssStyle"
                [cssClass]="select_3.cssClass"
                [borderSettings]="select_3.borderSettings"
                [sizeSettings]="select_3.sizeSettings"
                [colorSettings]="select_3.colorSettings"
                [boxShadowSettings]="select_3.boxShadowSettings"
                [paddingSettings]="select_3.paddingSettings"
                [marginSettings]="select_3.marginSettings"
                [size]="select_3.size"
                [settings]="select_3.settings"
                [options]="select_3.options"
              >
              </rappider-select>
            </div>

            <div class="rappider-component input-button input-settings">
              <!-- Component: Input Group 4 -->
              <rappider-input-group
                [prefixIcon]="inputGroup_4.prefixIcon"
                [suffixIcon]="inputGroup_4.suffixIcon"
                [prefixButton]="inputGroup_4.prefixButton"
                [suffixButton]="inputGroup_4.suffixButton"
                [textbox]="inputGroup_4.textbox"
                [prefixText]="inputGroup_4.prefixText"
                [suffixText]="inputGroup_4.suffixText"
              >
              </rappider-input-group>
            </div>
          </div>

          <!-- Container: Container 8 -->
          <div
            class="rappider-container container-8 col-2 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Icon 5 -->
              <rappider-icon
                [name]="icon_5.name"
                [color]="icon_5.color"
                [size]="icon_5.size"
                [type]="icon_5.type"
                [theme]="icon_5.theme"
                [animation]="icon_5.animation"
                [style]="icon_5.style"
                [secondColor]="icon_5.secondColor"
              >
              </rappider-icon>
            </div>

            <div class="rappider-component">
              <!-- Component: Button 6 -->
              <rappider-button
                [text]="button_6.text"
                [type]="button_6.type"
                [shape]="button_6.shape"
                [size]="button_6.size"
                [colorType]="button_6.colorType"
                [icon]="button_6.icon"
                [iconPlacement]="button_6.iconPlacement"
                [transparent]="button_6.transparent"
                [loading]="button_6.loading"
                [block]="button_6.block"
                [disabled]="button_6.disabled"
                [key]="button_6.key"
                [emitWithoutPopconfirm]="button_6.emitWithoutPopconfirm"
                [popconfirmTitle]="button_6.popconfirmTitle"
                [borderSettings]="button_6.borderSettings"
                [marginSettings]="button_6.marginSettings"
                [paddingSettings]="button_6.paddingSettings"
                [shadowSettings]="button_6.shadowSettings"
                [customColorSettings]="button_6.customColorSettings"
                [customSizeSettings]="button_6.customSizeSettings"
              >
              </rappider-button>
            </div>

            <div class="rappider-component">
              <!-- Component: Button 7 -->
              <rappider-button
                [text]="button_7.text"
                [type]="button_7.type"
                [shape]="button_7.shape"
                [size]="button_7.size"
                [colorType]="button_7.colorType"
                [icon]="button_7.icon"
                [iconPlacement]="button_7.iconPlacement"
                [transparent]="button_7.transparent"
                [loading]="button_7.loading"
                [block]="button_7.block"
                [disabled]="button_7.disabled"
                [key]="button_7.key"
                [emitWithoutPopconfirm]="button_7.emitWithoutPopconfirm"
                [popconfirmTitle]="button_7.popconfirmTitle"
                [borderSettings]="button_7.borderSettings"
                [marginSettings]="button_7.marginSettings"
                [paddingSettings]="button_7.paddingSettings"
                [shadowSettings]="button_7.shadowSettings"
                [customColorSettings]="button_7.customColorSettings"
                [customSizeSettings]="button_7.customSizeSettings"
              >
              </rappider-button>
            </div>
          </div>
        </div>

        <!-- Container: Container 9 -->
        <div
          class="rappider-container container-9 col-12 container-spacing-settings mobile-navbar-bg mobile-navbar-settings"
        >
          <!-- Container: Container 10 -->
          <div
            class="rappider-container container-10 col-12 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Image 8 -->
              <rappider-image
                [source]="image_8.source"
                [alternateText]="image_8.alternateText"
                [placeholder]="image_8.placeholder"
                [disablePreview]="image_8.disablePreview"
                [borderSettings]="image_8.borderSettings"
                [shadowSettings]="image_8.shadowSettings"
                [paddingSettings]="image_8.paddingSettings"
                [marginSettings]="image_8.marginSettings"
                [customSizeSettings]="image_8.customSizeSettings"
              >
              </rappider-image>
            </div>

            <!-- Container: Container 11 -->
            <div
              class="rappider-container container-11 col-1 container-spacing-settings"
            >
              <div class="rappider-component">
                <!-- Component: Cart Preview  9 -->
                <rappider-cart-preview
                  [cartItem]="cartPreview_9.cartItem"
                  [footer]="cartPreview_9.footer"
                  [footerContent]="cartPreview_9.footerContent"
                  [buttons]="cartPreview_9.buttons"
                  [dropdownButton]="cartPreview_9.dropdownButton"
                  [placement]="cartPreview_9.placement"
                  [triggerType]="cartPreview_9.triggerType"
                >
                </rappider-cart-preview>
              </div>

              <div class="rappider-component">
                <!-- Component: Icon 10 -->
                <rappider-icon
                  [name]="icon_10.name"
                  [color]="icon_10.color"
                  [size]="icon_10.size"
                  [type]="icon_10.type"
                  [theme]="icon_10.theme"
                  [animation]="icon_10.animation"
                  [style]="icon_10.style"
                  [secondColor]="icon_10.secondColor"
                >
                </rappider-icon>
              </div>
            </div>
          </div>

          <!-- Container: Container 12 -->
          <div
            class="rappider-container container-12 col-12 container-spacing-settings navbar-mobile-bg"
          >
            <div class="rappider-component">
              <!-- Component: Input Group 11 -->
              <rappider-input-group
                [prefixIcon]="inputGroup_11.prefixIcon"
                [suffixIcon]="inputGroup_11.suffixIcon"
                [prefixButton]="inputGroup_11.prefixButton"
                [suffixButton]="inputGroup_11.suffixButton"
                [textbox]="inputGroup_11.textbox"
                [prefixText]="inputGroup_11.prefixText"
                [suffixText]="inputGroup_11.suffixText"
              >
              </rappider-input-group>
            </div>
          </div>
        </div>

        <!-- Container: Container 13 -->
        <div
          class="rappider-container container-13 col-12 hidden-mw480 p-0 m-0"
        >
          <div class="rappider-component">
            <!-- Component: Menu 12 -->
            <rappider-menu
              [config]="menu_12.config"
              [isCollapsed]="menu_12.isCollapsed"
              [paddingValue]="menu_12.paddingValue"
              [menuPlacement]="menu_12.menuPlacement"
            >
            </rappider-menu>
          </div>

          <!-- Container: Container 14 -->
          <div class="rappider-container container-14 col-6 p-0 gap-2">
            <div class="rappider-component">
              <!-- Component: Button 13 -->
              <rappider-button
                [text]="button_13.text"
                [type]="button_13.type"
                [shape]="button_13.shape"
                [size]="button_13.size"
                [colorType]="button_13.colorType"
                [icon]="button_13.icon"
                [iconPlacement]="button_13.iconPlacement"
                [transparent]="button_13.transparent"
                [loading]="button_13.loading"
                [block]="button_13.block"
                [disabled]="button_13.disabled"
                [key]="button_13.key"
                [emitWithoutPopconfirm]="button_13.emitWithoutPopconfirm"
                [popconfirmTitle]="button_13.popconfirmTitle"
                [borderSettings]="button_13.borderSettings"
                [marginSettings]="button_13.marginSettings"
                [paddingSettings]="button_13.paddingSettings"
                [shadowSettings]="button_13.shadowSettings"
                [customColorSettings]="button_13.customColorSettings"
                [customSizeSettings]="button_13.customSizeSettings"
              >
              </rappider-button>
            </div>

            <div class="rappider-component">
              <!-- Component: Button 14 -->
              <rappider-button
                [text]="button_14.text"
                [type]="button_14.type"
                [shape]="button_14.shape"
                [size]="button_14.size"
                [colorType]="button_14.colorType"
                [icon]="button_14.icon"
                [iconPlacement]="button_14.iconPlacement"
                [transparent]="button_14.transparent"
                [loading]="button_14.loading"
                [block]="button_14.block"
                [disabled]="button_14.disabled"
                [key]="button_14.key"
                [emitWithoutPopconfirm]="button_14.emitWithoutPopconfirm"
                [popconfirmTitle]="button_14.popconfirmTitle"
                [borderSettings]="button_14.borderSettings"
                [marginSettings]="button_14.marginSettings"
                [paddingSettings]="button_14.paddingSettings"
                [shadowSettings]="button_14.shadowSettings"
                [customColorSettings]="button_14.customColorSettings"
                [customSizeSettings]="button_14.customSizeSettings"
              >
              </rappider-button>
            </div>

            <div class="rappider-component">
              <!-- Component: Dropdown Menu 15 -->
              <rappider-dropdown-menu
                [icon]="dropdownMenu_15.icon"
                [placement]="dropdownMenu_15.placement"
                [triggerType]="dropdownMenu_15.triggerType"
                [items]="dropdownMenu_15.items"
                [label]="dropdownMenu_15.label"
                [labelMode]="dropdownMenu_15.labelMode"
              >
              </rappider-dropdown-menu>
            </div>

            <div class="rappider-component">
              <!-- Component: Dropdown Menu 16 -->
              <rappider-dropdown-menu
                [icon]="dropdownMenu_16.icon"
                [placement]="dropdownMenu_16.placement"
                [triggerType]="dropdownMenu_16.triggerType"
                [items]="dropdownMenu_16.items"
                [label]="dropdownMenu_16.label"
                [labelMode]="dropdownMenu_16.labelMode"
              >
              </rappider-dropdown-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 15 -->
  <div class="rappider-container container-15 col-12">
    <!-- Container: Container 16 -->
    <div class="rappider-container container-16 col-12">
      <!-- Container: Container 17 -->
      <div class="rappider-container container-17 col-7">
        <div class="rappider-component">
          <!-- Component: Heading 17 -->
          <rappider-heading
            [content]="heading_17.content"
            [type]="heading_17.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Text 18 -->
          <rappider-text
            [textMode]="text_18.textMode"
            [text]="text_18.text"
            [content]="text_18.content"
            [typography]="text_18.typography"
            [colorSettings]="text_18.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 18 -->
      <div class="rappider-container container-18 col-5">
        <div class="rappider-component">
          <!-- Component: Textbox 19 -->
          <rappider-textbox
            [placeholder]="textbox_19.placeholder"
            [type]="textbox_19.type"
            [mask]="textbox_19.mask"
            [maskGuide]="textbox_19.maskGuide"
            [cssStyle]="textbox_19.cssStyle"
            [cssClass]="textbox_19.cssClass"
            [disabled]="textbox_19.disabled"
            [mentionSupported]="textbox_19.mentionSupported"
            [mentionPrefix]="textbox_19.mentionPrefix"
            [mentionValues]="textbox_19.mentionValues"
            [borderSettings]="textbox_19.borderSettings"
            [sizeSettings]="textbox_19.sizeSettings"
            [colorSettings]="textbox_19.colorSettings"
            [boxShadowSettings]="textbox_19.boxShadowSettings"
            [paddingSettings]="textbox_19.paddingSettings"
            [marginSettings]="textbox_19.marginSettings"
            [size]="textbox_19.size"
          >
          </rappider-textbox>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 20 -->
          <rappider-button
            [text]="button_20.text"
            [type]="button_20.type"
            [shape]="button_20.shape"
            [size]="button_20.size"
            [colorType]="button_20.colorType"
            [icon]="button_20.icon"
            [iconPlacement]="button_20.iconPlacement"
            [transparent]="button_20.transparent"
            [loading]="button_20.loading"
            [block]="button_20.block"
            [disabled]="button_20.disabled"
            [key]="button_20.key"
            [emitWithoutPopconfirm]="button_20.emitWithoutPopconfirm"
            [popconfirmTitle]="button_20.popconfirmTitle"
            [borderSettings]="button_20.borderSettings"
            [marginSettings]="button_20.marginSettings"
            [paddingSettings]="button_20.paddingSettings"
            [shadowSettings]="button_20.shadowSettings"
            [customColorSettings]="button_20.customColorSettings"
            [customSizeSettings]="button_20.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 19 -->
    <div class="rappider-container container-19 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 21 -->
        <rappider-divider
          [style]="divider_21.style"
          [type]="divider_21.type"
          [text]="divider_21.text"
          [textPlacement]="divider_21.textPlacement"
          [dividerWidth]="divider_21.dividerWidth"
          [dividerColor]="divider_21.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 20 -->
    <div class="rappider-container container-20 col-12">
      <!-- Container: Container 21 -->
      <div class="rappider-container container-21 col-5">
        <!-- Container: Container 22 -->
        <div class="rappider-container container-22 col-12">
          <div class="rappider-component">
            <!-- Component: Heading 22 -->
            <rappider-heading
              [content]="heading_22.content"
              [type]="heading_22.type"
            >
            </rappider-heading>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 23 -->
            <rappider-text
              [textMode]="text_23.textMode"
              [text]="text_23.text"
              [content]="text_23.content"
              [typography]="text_23.typography"
              [colorSettings]="text_23.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 24 -->
            <rappider-text
              [textMode]="text_24.textMode"
              [text]="text_24.text"
              [content]="text_24.content"
              [typography]="text_24.typography"
              [colorSettings]="text_24.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 25 -->
            <rappider-text
              [textMode]="text_25.textMode"
              [text]="text_25.text"
              [content]="text_25.content"
              [typography]="text_25.typography"
              [colorSettings]="text_25.colorSettings"
            >
            </rappider-text>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 26 -->
            <rappider-text
              [textMode]="text_26.textMode"
              [text]="text_26.text"
              [content]="text_26.content"
              [typography]="text_26.typography"
              [colorSettings]="text_26.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 23 -->
        <div class="rappider-container container-23 col-12">
          <div class="rappider-component">
            <!-- Component: Icon 27 -->
            <rappider-icon
              [name]="icon_27.name"
              [color]="icon_27.color"
              [size]="icon_27.size"
              [type]="icon_27.type"
              [theme]="icon_27.theme"
              [animation]="icon_27.animation"
              [style]="icon_27.style"
              [secondColor]="icon_27.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 28 -->
            <rappider-icon
              [name]="icon_28.name"
              [color]="icon_28.color"
              [size]="icon_28.size"
              [type]="icon_28.type"
              [theme]="icon_28.theme"
              [animation]="icon_28.animation"
              [style]="icon_28.style"
              [secondColor]="icon_28.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 29 -->
            <rappider-icon
              [name]="icon_29.name"
              [color]="icon_29.color"
              [size]="icon_29.size"
              [type]="icon_29.type"
              [theme]="icon_29.theme"
              [animation]="icon_29.animation"
              [style]="icon_29.style"
              [secondColor]="icon_29.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 30 -->
            <rappider-icon
              [name]="icon_30.name"
              [color]="icon_30.color"
              [size]="icon_30.size"
              [type]="icon_30.type"
              [theme]="icon_30.theme"
              [animation]="icon_30.animation"
              [style]="icon_30.style"
              [secondColor]="icon_30.secondColor"
            >
            </rappider-icon>
          </div>
        </div>
      </div>

      <!-- Container: Container 24 -->
      <div class="rappider-container container-24 col-2">
        <div class="rappider-component">
          <!-- Component: Heading 31 -->
          <rappider-heading
            [content]="heading_31.content"
            [type]="heading_31.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 32 -->
          <rappider-button
            [text]="button_32.text"
            [type]="button_32.type"
            [shape]="button_32.shape"
            [size]="button_32.size"
            [colorType]="button_32.colorType"
            [icon]="button_32.icon"
            [iconPlacement]="button_32.iconPlacement"
            [transparent]="button_32.transparent"
            [loading]="button_32.loading"
            [block]="button_32.block"
            [disabled]="button_32.disabled"
            [key]="button_32.key"
            [emitWithoutPopconfirm]="button_32.emitWithoutPopconfirm"
            [popconfirmTitle]="button_32.popconfirmTitle"
            [borderSettings]="button_32.borderSettings"
            [marginSettings]="button_32.marginSettings"
            [paddingSettings]="button_32.paddingSettings"
            [shadowSettings]="button_32.shadowSettings"
            [customColorSettings]="button_32.customColorSettings"
            [customSizeSettings]="button_32.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 33 -->
          <rappider-button
            [text]="button_33.text"
            [type]="button_33.type"
            [shape]="button_33.shape"
            [size]="button_33.size"
            [colorType]="button_33.colorType"
            [icon]="button_33.icon"
            [iconPlacement]="button_33.iconPlacement"
            [transparent]="button_33.transparent"
            [loading]="button_33.loading"
            [block]="button_33.block"
            [disabled]="button_33.disabled"
            [key]="button_33.key"
            [emitWithoutPopconfirm]="button_33.emitWithoutPopconfirm"
            [popconfirmTitle]="button_33.popconfirmTitle"
            [borderSettings]="button_33.borderSettings"
            [marginSettings]="button_33.marginSettings"
            [paddingSettings]="button_33.paddingSettings"
            [shadowSettings]="button_33.shadowSettings"
            [customColorSettings]="button_33.customColorSettings"
            [customSizeSettings]="button_33.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 34 -->
          <rappider-button
            [text]="button_34.text"
            [type]="button_34.type"
            [shape]="button_34.shape"
            [size]="button_34.size"
            [colorType]="button_34.colorType"
            [icon]="button_34.icon"
            [iconPlacement]="button_34.iconPlacement"
            [transparent]="button_34.transparent"
            [loading]="button_34.loading"
            [block]="button_34.block"
            [disabled]="button_34.disabled"
            [key]="button_34.key"
            [emitWithoutPopconfirm]="button_34.emitWithoutPopconfirm"
            [popconfirmTitle]="button_34.popconfirmTitle"
            [borderSettings]="button_34.borderSettings"
            [marginSettings]="button_34.marginSettings"
            [paddingSettings]="button_34.paddingSettings"
            [shadowSettings]="button_34.shadowSettings"
            [customColorSettings]="button_34.customColorSettings"
            [customSizeSettings]="button_34.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 35 -->
          <rappider-button
            [text]="button_35.text"
            [type]="button_35.type"
            [shape]="button_35.shape"
            [size]="button_35.size"
            [colorType]="button_35.colorType"
            [icon]="button_35.icon"
            [iconPlacement]="button_35.iconPlacement"
            [transparent]="button_35.transparent"
            [loading]="button_35.loading"
            [block]="button_35.block"
            [disabled]="button_35.disabled"
            [key]="button_35.key"
            [emitWithoutPopconfirm]="button_35.emitWithoutPopconfirm"
            [popconfirmTitle]="button_35.popconfirmTitle"
            [borderSettings]="button_35.borderSettings"
            [marginSettings]="button_35.marginSettings"
            [paddingSettings]="button_35.paddingSettings"
            [shadowSettings]="button_35.shadowSettings"
            [customColorSettings]="button_35.customColorSettings"
            [customSizeSettings]="button_35.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 36 -->
          <rappider-button
            [text]="button_36.text"
            [type]="button_36.type"
            [shape]="button_36.shape"
            [size]="button_36.size"
            [colorType]="button_36.colorType"
            [icon]="button_36.icon"
            [iconPlacement]="button_36.iconPlacement"
            [transparent]="button_36.transparent"
            [loading]="button_36.loading"
            [block]="button_36.block"
            [disabled]="button_36.disabled"
            [key]="button_36.key"
            [emitWithoutPopconfirm]="button_36.emitWithoutPopconfirm"
            [popconfirmTitle]="button_36.popconfirmTitle"
            [borderSettings]="button_36.borderSettings"
            [marginSettings]="button_36.marginSettings"
            [paddingSettings]="button_36.paddingSettings"
            [shadowSettings]="button_36.shadowSettings"
            [customColorSettings]="button_36.customColorSettings"
            [customSizeSettings]="button_36.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 25 -->
      <div class="rappider-container container-25 col-2">
        <div class="rappider-component">
          <!-- Component: Heading 37 -->
          <rappider-heading
            [content]="heading_37.content"
            [type]="heading_37.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 38 -->
          <rappider-button
            [text]="button_38.text"
            [type]="button_38.type"
            [shape]="button_38.shape"
            [size]="button_38.size"
            [colorType]="button_38.colorType"
            [icon]="button_38.icon"
            [iconPlacement]="button_38.iconPlacement"
            [transparent]="button_38.transparent"
            [loading]="button_38.loading"
            [block]="button_38.block"
            [disabled]="button_38.disabled"
            [key]="button_38.key"
            [emitWithoutPopconfirm]="button_38.emitWithoutPopconfirm"
            [popconfirmTitle]="button_38.popconfirmTitle"
            [borderSettings]="button_38.borderSettings"
            [marginSettings]="button_38.marginSettings"
            [paddingSettings]="button_38.paddingSettings"
            [shadowSettings]="button_38.shadowSettings"
            [customColorSettings]="button_38.customColorSettings"
            [customSizeSettings]="button_38.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 39 -->
          <rappider-button
            [text]="button_39.text"
            [type]="button_39.type"
            [shape]="button_39.shape"
            [size]="button_39.size"
            [colorType]="button_39.colorType"
            [icon]="button_39.icon"
            [iconPlacement]="button_39.iconPlacement"
            [transparent]="button_39.transparent"
            [loading]="button_39.loading"
            [block]="button_39.block"
            [disabled]="button_39.disabled"
            [key]="button_39.key"
            [emitWithoutPopconfirm]="button_39.emitWithoutPopconfirm"
            [popconfirmTitle]="button_39.popconfirmTitle"
            [borderSettings]="button_39.borderSettings"
            [marginSettings]="button_39.marginSettings"
            [paddingSettings]="button_39.paddingSettings"
            [shadowSettings]="button_39.shadowSettings"
            [customColorSettings]="button_39.customColorSettings"
            [customSizeSettings]="button_39.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 40 -->
          <rappider-button
            [text]="button_40.text"
            [type]="button_40.type"
            [shape]="button_40.shape"
            [size]="button_40.size"
            [colorType]="button_40.colorType"
            [icon]="button_40.icon"
            [iconPlacement]="button_40.iconPlacement"
            [transparent]="button_40.transparent"
            [loading]="button_40.loading"
            [block]="button_40.block"
            [disabled]="button_40.disabled"
            [key]="button_40.key"
            [emitWithoutPopconfirm]="button_40.emitWithoutPopconfirm"
            [popconfirmTitle]="button_40.popconfirmTitle"
            [borderSettings]="button_40.borderSettings"
            [marginSettings]="button_40.marginSettings"
            [paddingSettings]="button_40.paddingSettings"
            [shadowSettings]="button_40.shadowSettings"
            [customColorSettings]="button_40.customColorSettings"
            [customSizeSettings]="button_40.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 41 -->
          <rappider-button
            [text]="button_41.text"
            [type]="button_41.type"
            [shape]="button_41.shape"
            [size]="button_41.size"
            [colorType]="button_41.colorType"
            [icon]="button_41.icon"
            [iconPlacement]="button_41.iconPlacement"
            [transparent]="button_41.transparent"
            [loading]="button_41.loading"
            [block]="button_41.block"
            [disabled]="button_41.disabled"
            [key]="button_41.key"
            [emitWithoutPopconfirm]="button_41.emitWithoutPopconfirm"
            [popconfirmTitle]="button_41.popconfirmTitle"
            [borderSettings]="button_41.borderSettings"
            [marginSettings]="button_41.marginSettings"
            [paddingSettings]="button_41.paddingSettings"
            [shadowSettings]="button_41.shadowSettings"
            [customColorSettings]="button_41.customColorSettings"
            [customSizeSettings]="button_41.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 26 -->
      <div class="rappider-container container-26 col-2">
        <div class="rappider-component">
          <!-- Component: Heading 42 -->
          <rappider-heading
            [content]="heading_42.content"
            [type]="heading_42.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 43 -->
          <rappider-button
            [text]="button_43.text"
            [type]="button_43.type"
            [shape]="button_43.shape"
            [size]="button_43.size"
            [colorType]="button_43.colorType"
            [icon]="button_43.icon"
            [iconPlacement]="button_43.iconPlacement"
            [transparent]="button_43.transparent"
            [loading]="button_43.loading"
            [block]="button_43.block"
            [disabled]="button_43.disabled"
            [key]="button_43.key"
            [emitWithoutPopconfirm]="button_43.emitWithoutPopconfirm"
            [popconfirmTitle]="button_43.popconfirmTitle"
            [borderSettings]="button_43.borderSettings"
            [marginSettings]="button_43.marginSettings"
            [paddingSettings]="button_43.paddingSettings"
            [shadowSettings]="button_43.shadowSettings"
            [customColorSettings]="button_43.customColorSettings"
            [customSizeSettings]="button_43.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 44 -->
          <rappider-button
            [text]="button_44.text"
            [type]="button_44.type"
            [shape]="button_44.shape"
            [size]="button_44.size"
            [colorType]="button_44.colorType"
            [icon]="button_44.icon"
            [iconPlacement]="button_44.iconPlacement"
            [transparent]="button_44.transparent"
            [loading]="button_44.loading"
            [block]="button_44.block"
            [disabled]="button_44.disabled"
            [key]="button_44.key"
            [emitWithoutPopconfirm]="button_44.emitWithoutPopconfirm"
            [popconfirmTitle]="button_44.popconfirmTitle"
            [borderSettings]="button_44.borderSettings"
            [marginSettings]="button_44.marginSettings"
            [paddingSettings]="button_44.paddingSettings"
            [shadowSettings]="button_44.shadowSettings"
            [customColorSettings]="button_44.customColorSettings"
            [customSizeSettings]="button_44.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 45 -->
          <rappider-button
            [text]="button_45.text"
            [type]="button_45.type"
            [shape]="button_45.shape"
            [size]="button_45.size"
            [colorType]="button_45.colorType"
            [icon]="button_45.icon"
            [iconPlacement]="button_45.iconPlacement"
            [transparent]="button_45.transparent"
            [loading]="button_45.loading"
            [block]="button_45.block"
            [disabled]="button_45.disabled"
            [key]="button_45.key"
            [emitWithoutPopconfirm]="button_45.emitWithoutPopconfirm"
            [popconfirmTitle]="button_45.popconfirmTitle"
            [borderSettings]="button_45.borderSettings"
            [marginSettings]="button_45.marginSettings"
            [paddingSettings]="button_45.paddingSettings"
            [shadowSettings]="button_45.shadowSettings"
            [customColorSettings]="button_45.customColorSettings"
            [customSizeSettings]="button_45.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 46 -->
          <rappider-button
            [text]="button_46.text"
            [type]="button_46.type"
            [shape]="button_46.shape"
            [size]="button_46.size"
            [colorType]="button_46.colorType"
            [icon]="button_46.icon"
            [iconPlacement]="button_46.iconPlacement"
            [transparent]="button_46.transparent"
            [loading]="button_46.loading"
            [block]="button_46.block"
            [disabled]="button_46.disabled"
            [key]="button_46.key"
            [emitWithoutPopconfirm]="button_46.emitWithoutPopconfirm"
            [popconfirmTitle]="button_46.popconfirmTitle"
            [borderSettings]="button_46.borderSettings"
            [marginSettings]="button_46.marginSettings"
            [paddingSettings]="button_46.paddingSettings"
            [shadowSettings]="button_46.shadowSettings"
            [customColorSettings]="button_46.customColorSettings"
            [customSizeSettings]="button_46.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>

    <!-- Container: Container 27 -->
    <div class="rappider-container container-27 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 47 -->
        <rappider-divider
          [style]="divider_47.style"
          [type]="divider_47.type"
          [text]="divider_47.text"
          [textPlacement]="divider_47.textPlacement"
          [dividerWidth]="divider_47.dividerWidth"
          [dividerColor]="divider_47.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 28 -->
    <div class="rappider-container container-28 col-12">
      <!-- Container: Container 29 -->
      <div
        class="rappider-container container-29 col-12 container-spacing-settings"
      >
        <!-- Container: Container 30 -->
        <div class="rappider-container container-30 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 48 -->
            <rappider-text
              [textMode]="text_48.textMode"
              [text]="text_48.text"
              [content]="text_48.content"
              [typography]="text_48.typography"
              [colorSettings]="text_48.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 31 -->
        <div
          class="rappider-container container-31 col-7 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 49 -->
            <rappider-button
              [text]="button_49.text"
              [type]="button_49.type"
              [shape]="button_49.shape"
              [size]="button_49.size"
              [colorType]="button_49.colorType"
              [icon]="button_49.icon"
              [iconPlacement]="button_49.iconPlacement"
              [transparent]="button_49.transparent"
              [loading]="button_49.loading"
              [block]="button_49.block"
              [disabled]="button_49.disabled"
              [key]="button_49.key"
              [emitWithoutPopconfirm]="button_49.emitWithoutPopconfirm"
              [popconfirmTitle]="button_49.popconfirmTitle"
              [borderSettings]="button_49.borderSettings"
              [marginSettings]="button_49.marginSettings"
              [paddingSettings]="button_49.paddingSettings"
              [shadowSettings]="button_49.shadowSettings"
              [customColorSettings]="button_49.customColorSettings"
              [customSizeSettings]="button_49.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 50 -->
            <rappider-button
              [text]="button_50.text"
              [type]="button_50.type"
              [shape]="button_50.shape"
              [size]="button_50.size"
              [colorType]="button_50.colorType"
              [icon]="button_50.icon"
              [iconPlacement]="button_50.iconPlacement"
              [transparent]="button_50.transparent"
              [loading]="button_50.loading"
              [block]="button_50.block"
              [disabled]="button_50.disabled"
              [key]="button_50.key"
              [emitWithoutPopconfirm]="button_50.emitWithoutPopconfirm"
              [popconfirmTitle]="button_50.popconfirmTitle"
              [borderSettings]="button_50.borderSettings"
              [marginSettings]="button_50.marginSettings"
              [paddingSettings]="button_50.paddingSettings"
              [shadowSettings]="button_50.shadowSettings"
              [customColorSettings]="button_50.customColorSettings"
              [customSizeSettings]="button_50.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 51 -->
            <rappider-button
              [text]="button_51.text"
              [type]="button_51.type"
              [shape]="button_51.shape"
              [size]="button_51.size"
              [colorType]="button_51.colorType"
              [icon]="button_51.icon"
              [iconPlacement]="button_51.iconPlacement"
              [transparent]="button_51.transparent"
              [loading]="button_51.loading"
              [block]="button_51.block"
              [disabled]="button_51.disabled"
              [key]="button_51.key"
              [emitWithoutPopconfirm]="button_51.emitWithoutPopconfirm"
              [popconfirmTitle]="button_51.popconfirmTitle"
              [borderSettings]="button_51.borderSettings"
              [marginSettings]="button_51.marginSettings"
              [paddingSettings]="button_51.paddingSettings"
              [shadowSettings]="button_51.shadowSettings"
              [customColorSettings]="button_51.customColorSettings"
              [customSizeSettings]="button_51.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 52 -->
            <rappider-button
              [text]="button_52.text"
              [type]="button_52.type"
              [shape]="button_52.shape"
              [size]="button_52.size"
              [colorType]="button_52.colorType"
              [icon]="button_52.icon"
              [iconPlacement]="button_52.iconPlacement"
              [transparent]="button_52.transparent"
              [loading]="button_52.loading"
              [block]="button_52.block"
              [disabled]="button_52.disabled"
              [key]="button_52.key"
              [emitWithoutPopconfirm]="button_52.emitWithoutPopconfirm"
              [popconfirmTitle]="button_52.popconfirmTitle"
              [borderSettings]="button_52.borderSettings"
              [marginSettings]="button_52.marginSettings"
              [paddingSettings]="button_52.paddingSettings"
              [shadowSettings]="button_52.shadowSettings"
              [customColorSettings]="button_52.customColorSettings"
              [customSizeSettings]="button_52.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 53 -->
            <rappider-button
              [text]="button_53.text"
              [type]="button_53.type"
              [shape]="button_53.shape"
              [size]="button_53.size"
              [colorType]="button_53.colorType"
              [icon]="button_53.icon"
              [iconPlacement]="button_53.iconPlacement"
              [transparent]="button_53.transparent"
              [loading]="button_53.loading"
              [block]="button_53.block"
              [disabled]="button_53.disabled"
              [key]="button_53.key"
              [emitWithoutPopconfirm]="button_53.emitWithoutPopconfirm"
              [popconfirmTitle]="button_53.popconfirmTitle"
              [borderSettings]="button_53.borderSettings"
              [marginSettings]="button_53.marginSettings"
              [paddingSettings]="button_53.paddingSettings"
              [shadowSettings]="button_53.shadowSettings"
              [customColorSettings]="button_53.customColorSettings"
              [customSizeSettings]="button_53.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 54 -->
            <rappider-button
              [text]="button_54.text"
              [type]="button_54.type"
              [shape]="button_54.shape"
              [size]="button_54.size"
              [colorType]="button_54.colorType"
              [icon]="button_54.icon"
              [iconPlacement]="button_54.iconPlacement"
              [transparent]="button_54.transparent"
              [loading]="button_54.loading"
              [block]="button_54.block"
              [disabled]="button_54.disabled"
              [key]="button_54.key"
              [emitWithoutPopconfirm]="button_54.emitWithoutPopconfirm"
              [popconfirmTitle]="button_54.popconfirmTitle"
              [borderSettings]="button_54.borderSettings"
              [marginSettings]="button_54.marginSettings"
              [paddingSettings]="button_54.paddingSettings"
              [shadowSettings]="button_54.shadowSettings"
              [customColorSettings]="button_54.customColorSettings"
              [customSizeSettings]="button_54.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 32 -->
      <div
        class="rappider-container container-32 col-12 container-spacing-settings"
      >
        <!-- Container: Container 33 -->
        <div class="rappider-container container-33 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 55 -->
            <rappider-text
              [textMode]="text_55.textMode"
              [text]="text_55.text"
              [content]="text_55.content"
              [typography]="text_55.typography"
              [colorSettings]="text_55.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 34 -->
        <div
          class="rappider-container container-34 col-6 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 56 -->
            <rappider-button
              [text]="button_56.text"
              [type]="button_56.type"
              [shape]="button_56.shape"
              [size]="button_56.size"
              [colorType]="button_56.colorType"
              [icon]="button_56.icon"
              [iconPlacement]="button_56.iconPlacement"
              [transparent]="button_56.transparent"
              [loading]="button_56.loading"
              [block]="button_56.block"
              [disabled]="button_56.disabled"
              [key]="button_56.key"
              [emitWithoutPopconfirm]="button_56.emitWithoutPopconfirm"
              [popconfirmTitle]="button_56.popconfirmTitle"
              [borderSettings]="button_56.borderSettings"
              [marginSettings]="button_56.marginSettings"
              [paddingSettings]="button_56.paddingSettings"
              [shadowSettings]="button_56.shadowSettings"
              [customColorSettings]="button_56.customColorSettings"
              [customSizeSettings]="button_56.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 57 -->
            <rappider-button
              [text]="button_57.text"
              [type]="button_57.type"
              [shape]="button_57.shape"
              [size]="button_57.size"
              [colorType]="button_57.colorType"
              [icon]="button_57.icon"
              [iconPlacement]="button_57.iconPlacement"
              [transparent]="button_57.transparent"
              [loading]="button_57.loading"
              [block]="button_57.block"
              [disabled]="button_57.disabled"
              [key]="button_57.key"
              [emitWithoutPopconfirm]="button_57.emitWithoutPopconfirm"
              [popconfirmTitle]="button_57.popconfirmTitle"
              [borderSettings]="button_57.borderSettings"
              [marginSettings]="button_57.marginSettings"
              [paddingSettings]="button_57.paddingSettings"
              [shadowSettings]="button_57.shadowSettings"
              [customColorSettings]="button_57.customColorSettings"
              [customSizeSettings]="button_57.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 58 -->
            <rappider-button
              [text]="button_58.text"
              [type]="button_58.type"
              [shape]="button_58.shape"
              [size]="button_58.size"
              [colorType]="button_58.colorType"
              [icon]="button_58.icon"
              [iconPlacement]="button_58.iconPlacement"
              [transparent]="button_58.transparent"
              [loading]="button_58.loading"
              [block]="button_58.block"
              [disabled]="button_58.disabled"
              [key]="button_58.key"
              [emitWithoutPopconfirm]="button_58.emitWithoutPopconfirm"
              [popconfirmTitle]="button_58.popconfirmTitle"
              [borderSettings]="button_58.borderSettings"
              [marginSettings]="button_58.marginSettings"
              [paddingSettings]="button_58.paddingSettings"
              [shadowSettings]="button_58.shadowSettings"
              [customColorSettings]="button_58.customColorSettings"
              [customSizeSettings]="button_58.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 59 -->
            <rappider-button
              [text]="button_59.text"
              [type]="button_59.type"
              [shape]="button_59.shape"
              [size]="button_59.size"
              [colorType]="button_59.colorType"
              [icon]="button_59.icon"
              [iconPlacement]="button_59.iconPlacement"
              [transparent]="button_59.transparent"
              [loading]="button_59.loading"
              [block]="button_59.block"
              [disabled]="button_59.disabled"
              [key]="button_59.key"
              [emitWithoutPopconfirm]="button_59.emitWithoutPopconfirm"
              [popconfirmTitle]="button_59.popconfirmTitle"
              [borderSettings]="button_59.borderSettings"
              [marginSettings]="button_59.marginSettings"
              [paddingSettings]="button_59.paddingSettings"
              [shadowSettings]="button_59.shadowSettings"
              [customColorSettings]="button_59.customColorSettings"
              [customSizeSettings]="button_59.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 60 -->
            <rappider-button
              [text]="button_60.text"
              [type]="button_60.type"
              [shape]="button_60.shape"
              [size]="button_60.size"
              [colorType]="button_60.colorType"
              [icon]="button_60.icon"
              [iconPlacement]="button_60.iconPlacement"
              [transparent]="button_60.transparent"
              [loading]="button_60.loading"
              [block]="button_60.block"
              [disabled]="button_60.disabled"
              [key]="button_60.key"
              [emitWithoutPopconfirm]="button_60.emitWithoutPopconfirm"
              [popconfirmTitle]="button_60.popconfirmTitle"
              [borderSettings]="button_60.borderSettings"
              [marginSettings]="button_60.marginSettings"
              [paddingSettings]="button_60.paddingSettings"
              [shadowSettings]="button_60.shadowSettings"
              [customColorSettings]="button_60.customColorSettings"
              [customSizeSettings]="button_60.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 61 -->
            <rappider-button
              [text]="button_61.text"
              [type]="button_61.type"
              [shape]="button_61.shape"
              [size]="button_61.size"
              [colorType]="button_61.colorType"
              [icon]="button_61.icon"
              [iconPlacement]="button_61.iconPlacement"
              [transparent]="button_61.transparent"
              [loading]="button_61.loading"
              [block]="button_61.block"
              [disabled]="button_61.disabled"
              [key]="button_61.key"
              [emitWithoutPopconfirm]="button_61.emitWithoutPopconfirm"
              [popconfirmTitle]="button_61.popconfirmTitle"
              [borderSettings]="button_61.borderSettings"
              [marginSettings]="button_61.marginSettings"
              [paddingSettings]="button_61.paddingSettings"
              [shadowSettings]="button_61.shadowSettings"
              [customColorSettings]="button_61.customColorSettings"
              [customSizeSettings]="button_61.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 62 -->
            <rappider-button
              [text]="button_62.text"
              [type]="button_62.type"
              [shape]="button_62.shape"
              [size]="button_62.size"
              [colorType]="button_62.colorType"
              [icon]="button_62.icon"
              [iconPlacement]="button_62.iconPlacement"
              [transparent]="button_62.transparent"
              [loading]="button_62.loading"
              [block]="button_62.block"
              [disabled]="button_62.disabled"
              [key]="button_62.key"
              [emitWithoutPopconfirm]="button_62.emitWithoutPopconfirm"
              [popconfirmTitle]="button_62.popconfirmTitle"
              [borderSettings]="button_62.borderSettings"
              [marginSettings]="button_62.marginSettings"
              [paddingSettings]="button_62.paddingSettings"
              [shadowSettings]="button_62.shadowSettings"
              [customColorSettings]="button_62.customColorSettings"
              [customSizeSettings]="button_62.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 35 -->
      <div
        class="rappider-container container-35 col-12 container-spacing-settings"
      >
        <!-- Container: Container 36 -->
        <div class="rappider-container container-36 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 63 -->
            <rappider-text
              [textMode]="text_63.textMode"
              [text]="text_63.text"
              [content]="text_63.content"
              [typography]="text_63.typography"
              [colorSettings]="text_63.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 37 -->
        <div
          class="rappider-container container-37 col-8 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 64 -->
            <rappider-button
              [text]="button_64.text"
              [type]="button_64.type"
              [shape]="button_64.shape"
              [size]="button_64.size"
              [colorType]="button_64.colorType"
              [icon]="button_64.icon"
              [iconPlacement]="button_64.iconPlacement"
              [transparent]="button_64.transparent"
              [loading]="button_64.loading"
              [block]="button_64.block"
              [disabled]="button_64.disabled"
              [key]="button_64.key"
              [emitWithoutPopconfirm]="button_64.emitWithoutPopconfirm"
              [popconfirmTitle]="button_64.popconfirmTitle"
              [borderSettings]="button_64.borderSettings"
              [marginSettings]="button_64.marginSettings"
              [paddingSettings]="button_64.paddingSettings"
              [shadowSettings]="button_64.shadowSettings"
              [customColorSettings]="button_64.customColorSettings"
              [customSizeSettings]="button_64.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 65 -->
            <rappider-button
              [text]="button_65.text"
              [type]="button_65.type"
              [shape]="button_65.shape"
              [size]="button_65.size"
              [colorType]="button_65.colorType"
              [icon]="button_65.icon"
              [iconPlacement]="button_65.iconPlacement"
              [transparent]="button_65.transparent"
              [loading]="button_65.loading"
              [block]="button_65.block"
              [disabled]="button_65.disabled"
              [key]="button_65.key"
              [emitWithoutPopconfirm]="button_65.emitWithoutPopconfirm"
              [popconfirmTitle]="button_65.popconfirmTitle"
              [borderSettings]="button_65.borderSettings"
              [marginSettings]="button_65.marginSettings"
              [paddingSettings]="button_65.paddingSettings"
              [shadowSettings]="button_65.shadowSettings"
              [customColorSettings]="button_65.customColorSettings"
              [customSizeSettings]="button_65.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 66 -->
            <rappider-button
              [text]="button_66.text"
              [type]="button_66.type"
              [shape]="button_66.shape"
              [size]="button_66.size"
              [colorType]="button_66.colorType"
              [icon]="button_66.icon"
              [iconPlacement]="button_66.iconPlacement"
              [transparent]="button_66.transparent"
              [loading]="button_66.loading"
              [block]="button_66.block"
              [disabled]="button_66.disabled"
              [key]="button_66.key"
              [emitWithoutPopconfirm]="button_66.emitWithoutPopconfirm"
              [popconfirmTitle]="button_66.popconfirmTitle"
              [borderSettings]="button_66.borderSettings"
              [marginSettings]="button_66.marginSettings"
              [paddingSettings]="button_66.paddingSettings"
              [shadowSettings]="button_66.shadowSettings"
              [customColorSettings]="button_66.customColorSettings"
              [customSizeSettings]="button_66.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 67 -->
            <rappider-button
              [text]="button_67.text"
              [type]="button_67.type"
              [shape]="button_67.shape"
              [size]="button_67.size"
              [colorType]="button_67.colorType"
              [icon]="button_67.icon"
              [iconPlacement]="button_67.iconPlacement"
              [transparent]="button_67.transparent"
              [loading]="button_67.loading"
              [block]="button_67.block"
              [disabled]="button_67.disabled"
              [key]="button_67.key"
              [emitWithoutPopconfirm]="button_67.emitWithoutPopconfirm"
              [popconfirmTitle]="button_67.popconfirmTitle"
              [borderSettings]="button_67.borderSettings"
              [marginSettings]="button_67.marginSettings"
              [paddingSettings]="button_67.paddingSettings"
              [shadowSettings]="button_67.shadowSettings"
              [customColorSettings]="button_67.customColorSettings"
              [customSizeSettings]="button_67.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 68 -->
            <rappider-button
              [text]="button_68.text"
              [type]="button_68.type"
              [shape]="button_68.shape"
              [size]="button_68.size"
              [colorType]="button_68.colorType"
              [icon]="button_68.icon"
              [iconPlacement]="button_68.iconPlacement"
              [transparent]="button_68.transparent"
              [loading]="button_68.loading"
              [block]="button_68.block"
              [disabled]="button_68.disabled"
              [key]="button_68.key"
              [emitWithoutPopconfirm]="button_68.emitWithoutPopconfirm"
              [popconfirmTitle]="button_68.popconfirmTitle"
              [borderSettings]="button_68.borderSettings"
              [marginSettings]="button_68.marginSettings"
              [paddingSettings]="button_68.paddingSettings"
              [shadowSettings]="button_68.shadowSettings"
              [customColorSettings]="button_68.customColorSettings"
              [customSizeSettings]="button_68.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 69 -->
            <rappider-button
              [text]="button_69.text"
              [type]="button_69.type"
              [shape]="button_69.shape"
              [size]="button_69.size"
              [colorType]="button_69.colorType"
              [icon]="button_69.icon"
              [iconPlacement]="button_69.iconPlacement"
              [transparent]="button_69.transparent"
              [loading]="button_69.loading"
              [block]="button_69.block"
              [disabled]="button_69.disabled"
              [key]="button_69.key"
              [emitWithoutPopconfirm]="button_69.emitWithoutPopconfirm"
              [popconfirmTitle]="button_69.popconfirmTitle"
              [borderSettings]="button_69.borderSettings"
              [marginSettings]="button_69.marginSettings"
              [paddingSettings]="button_69.paddingSettings"
              [shadowSettings]="button_69.shadowSettings"
              [customColorSettings]="button_69.customColorSettings"
              [customSizeSettings]="button_69.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 70 -->
            <rappider-button
              [text]="button_70.text"
              [type]="button_70.type"
              [shape]="button_70.shape"
              [size]="button_70.size"
              [colorType]="button_70.colorType"
              [icon]="button_70.icon"
              [iconPlacement]="button_70.iconPlacement"
              [transparent]="button_70.transparent"
              [loading]="button_70.loading"
              [block]="button_70.block"
              [disabled]="button_70.disabled"
              [key]="button_70.key"
              [emitWithoutPopconfirm]="button_70.emitWithoutPopconfirm"
              [popconfirmTitle]="button_70.popconfirmTitle"
              [borderSettings]="button_70.borderSettings"
              [marginSettings]="button_70.marginSettings"
              [paddingSettings]="button_70.paddingSettings"
              [shadowSettings]="button_70.shadowSettings"
              [customColorSettings]="button_70.customColorSettings"
              [customSizeSettings]="button_70.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 38 -->
      <div
        class="rappider-container container-38 col-12 container-spacing-settings"
      >
        <!-- Container: Container 39 -->
        <div class="rappider-container container-39 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 71 -->
            <rappider-text
              [textMode]="text_71.textMode"
              [text]="text_71.text"
              [content]="text_71.content"
              [typography]="text_71.typography"
              [colorSettings]="text_71.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 40 -->
        <div
          class="rappider-container container-40 col-6 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Button 72 -->
            <rappider-button
              [text]="button_72.text"
              [type]="button_72.type"
              [shape]="button_72.shape"
              [size]="button_72.size"
              [colorType]="button_72.colorType"
              [icon]="button_72.icon"
              [iconPlacement]="button_72.iconPlacement"
              [transparent]="button_72.transparent"
              [loading]="button_72.loading"
              [block]="button_72.block"
              [disabled]="button_72.disabled"
              [key]="button_72.key"
              [emitWithoutPopconfirm]="button_72.emitWithoutPopconfirm"
              [popconfirmTitle]="button_72.popconfirmTitle"
              [borderSettings]="button_72.borderSettings"
              [marginSettings]="button_72.marginSettings"
              [paddingSettings]="button_72.paddingSettings"
              [shadowSettings]="button_72.shadowSettings"
              [customColorSettings]="button_72.customColorSettings"
              [customSizeSettings]="button_72.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 73 -->
            <rappider-button
              [text]="button_73.text"
              [type]="button_73.type"
              [shape]="button_73.shape"
              [size]="button_73.size"
              [colorType]="button_73.colorType"
              [icon]="button_73.icon"
              [iconPlacement]="button_73.iconPlacement"
              [transparent]="button_73.transparent"
              [loading]="button_73.loading"
              [block]="button_73.block"
              [disabled]="button_73.disabled"
              [key]="button_73.key"
              [emitWithoutPopconfirm]="button_73.emitWithoutPopconfirm"
              [popconfirmTitle]="button_73.popconfirmTitle"
              [borderSettings]="button_73.borderSettings"
              [marginSettings]="button_73.marginSettings"
              [paddingSettings]="button_73.paddingSettings"
              [shadowSettings]="button_73.shadowSettings"
              [customColorSettings]="button_73.customColorSettings"
              [customSizeSettings]="button_73.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 74 -->
            <rappider-button
              [text]="button_74.text"
              [type]="button_74.type"
              [shape]="button_74.shape"
              [size]="button_74.size"
              [colorType]="button_74.colorType"
              [icon]="button_74.icon"
              [iconPlacement]="button_74.iconPlacement"
              [transparent]="button_74.transparent"
              [loading]="button_74.loading"
              [block]="button_74.block"
              [disabled]="button_74.disabled"
              [key]="button_74.key"
              [emitWithoutPopconfirm]="button_74.emitWithoutPopconfirm"
              [popconfirmTitle]="button_74.popconfirmTitle"
              [borderSettings]="button_74.borderSettings"
              [marginSettings]="button_74.marginSettings"
              [paddingSettings]="button_74.paddingSettings"
              [shadowSettings]="button_74.shadowSettings"
              [customColorSettings]="button_74.customColorSettings"
              [customSizeSettings]="button_74.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 75 -->
            <rappider-button
              [text]="button_75.text"
              [type]="button_75.type"
              [shape]="button_75.shape"
              [size]="button_75.size"
              [colorType]="button_75.colorType"
              [icon]="button_75.icon"
              [iconPlacement]="button_75.iconPlacement"
              [transparent]="button_75.transparent"
              [loading]="button_75.loading"
              [block]="button_75.block"
              [disabled]="button_75.disabled"
              [key]="button_75.key"
              [emitWithoutPopconfirm]="button_75.emitWithoutPopconfirm"
              [popconfirmTitle]="button_75.popconfirmTitle"
              [borderSettings]="button_75.borderSettings"
              [marginSettings]="button_75.marginSettings"
              [paddingSettings]="button_75.paddingSettings"
              [shadowSettings]="button_75.shadowSettings"
              [customColorSettings]="button_75.customColorSettings"
              [customSizeSettings]="button_75.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 76 -->
            <rappider-button
              [text]="button_76.text"
              [type]="button_76.type"
              [shape]="button_76.shape"
              [size]="button_76.size"
              [colorType]="button_76.colorType"
              [icon]="button_76.icon"
              [iconPlacement]="button_76.iconPlacement"
              [transparent]="button_76.transparent"
              [loading]="button_76.loading"
              [block]="button_76.block"
              [disabled]="button_76.disabled"
              [key]="button_76.key"
              [emitWithoutPopconfirm]="button_76.emitWithoutPopconfirm"
              [popconfirmTitle]="button_76.popconfirmTitle"
              [borderSettings]="button_76.borderSettings"
              [marginSettings]="button_76.marginSettings"
              [paddingSettings]="button_76.paddingSettings"
              [shadowSettings]="button_76.shadowSettings"
              [customColorSettings]="button_76.customColorSettings"
              [customSizeSettings]="button_76.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 77 -->
            <rappider-button
              [text]="button_77.text"
              [type]="button_77.type"
              [shape]="button_77.shape"
              [size]="button_77.size"
              [colorType]="button_77.colorType"
              [icon]="button_77.icon"
              [iconPlacement]="button_77.iconPlacement"
              [transparent]="button_77.transparent"
              [loading]="button_77.loading"
              [block]="button_77.block"
              [disabled]="button_77.disabled"
              [key]="button_77.key"
              [emitWithoutPopconfirm]="button_77.emitWithoutPopconfirm"
              [popconfirmTitle]="button_77.popconfirmTitle"
              [borderSettings]="button_77.borderSettings"
              [marginSettings]="button_77.marginSettings"
              [paddingSettings]="button_77.paddingSettings"
              [shadowSettings]="button_77.shadowSettings"
              [customColorSettings]="button_77.customColorSettings"
              [customSizeSettings]="button_77.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 78 -->
            <rappider-button
              [text]="button_78.text"
              [type]="button_78.type"
              [shape]="button_78.shape"
              [size]="button_78.size"
              [colorType]="button_78.colorType"
              [icon]="button_78.icon"
              [iconPlacement]="button_78.iconPlacement"
              [transparent]="button_78.transparent"
              [loading]="button_78.loading"
              [block]="button_78.block"
              [disabled]="button_78.disabled"
              [key]="button_78.key"
              [emitWithoutPopconfirm]="button_78.emitWithoutPopconfirm"
              [popconfirmTitle]="button_78.popconfirmTitle"
              [borderSettings]="button_78.borderSettings"
              [marginSettings]="button_78.marginSettings"
              [paddingSettings]="button_78.paddingSettings"
              [shadowSettings]="button_78.shadowSettings"
              [customColorSettings]="button_78.customColorSettings"
              [customSizeSettings]="button_78.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 79 -->
            <rappider-button
              [text]="button_79.text"
              [type]="button_79.type"
              [shape]="button_79.shape"
              [size]="button_79.size"
              [colorType]="button_79.colorType"
              [icon]="button_79.icon"
              [iconPlacement]="button_79.iconPlacement"
              [transparent]="button_79.transparent"
              [loading]="button_79.loading"
              [block]="button_79.block"
              [disabled]="button_79.disabled"
              [key]="button_79.key"
              [emitWithoutPopconfirm]="button_79.emitWithoutPopconfirm"
              [popconfirmTitle]="button_79.popconfirmTitle"
              [borderSettings]="button_79.borderSettings"
              [marginSettings]="button_79.marginSettings"
              [paddingSettings]="button_79.paddingSettings"
              [shadowSettings]="button_79.shadowSettings"
              [customColorSettings]="button_79.customColorSettings"
              [customSizeSettings]="button_79.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 41 -->
      <div
        class="rappider-container container-41 col-12 container-spacing-settings"
      >
        <!-- Container: Container 42 -->
        <div class="rappider-container container-42 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 80 -->
            <rappider-text
              [textMode]="text_80.textMode"
              [text]="text_80.text"
              [content]="text_80.content"
              [typography]="text_80.typography"
              [colorSettings]="text_80.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 43 -->
        <div
          class="rappider-container container-43 col-6 container-spacing-settings container-width-100-mw480"
        >
          <div class="rappider-component">
            <!-- Component: Button 81 -->
            <rappider-button
              [text]="button_81.text"
              [type]="button_81.type"
              [shape]="button_81.shape"
              [size]="button_81.size"
              [colorType]="button_81.colorType"
              [icon]="button_81.icon"
              [iconPlacement]="button_81.iconPlacement"
              [transparent]="button_81.transparent"
              [loading]="button_81.loading"
              [block]="button_81.block"
              [disabled]="button_81.disabled"
              [key]="button_81.key"
              [emitWithoutPopconfirm]="button_81.emitWithoutPopconfirm"
              [popconfirmTitle]="button_81.popconfirmTitle"
              [borderSettings]="button_81.borderSettings"
              [marginSettings]="button_81.marginSettings"
              [paddingSettings]="button_81.paddingSettings"
              [shadowSettings]="button_81.shadowSettings"
              [customColorSettings]="button_81.customColorSettings"
              [customSizeSettings]="button_81.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 82 -->
            <rappider-button
              [text]="button_82.text"
              [type]="button_82.type"
              [shape]="button_82.shape"
              [size]="button_82.size"
              [colorType]="button_82.colorType"
              [icon]="button_82.icon"
              [iconPlacement]="button_82.iconPlacement"
              [transparent]="button_82.transparent"
              [loading]="button_82.loading"
              [block]="button_82.block"
              [disabled]="button_82.disabled"
              [key]="button_82.key"
              [emitWithoutPopconfirm]="button_82.emitWithoutPopconfirm"
              [popconfirmTitle]="button_82.popconfirmTitle"
              [borderSettings]="button_82.borderSettings"
              [marginSettings]="button_82.marginSettings"
              [paddingSettings]="button_82.paddingSettings"
              [shadowSettings]="button_82.shadowSettings"
              [customColorSettings]="button_82.customColorSettings"
              [customSizeSettings]="button_82.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 83 -->
            <rappider-button
              [text]="button_83.text"
              [type]="button_83.type"
              [shape]="button_83.shape"
              [size]="button_83.size"
              [colorType]="button_83.colorType"
              [icon]="button_83.icon"
              [iconPlacement]="button_83.iconPlacement"
              [transparent]="button_83.transparent"
              [loading]="button_83.loading"
              [block]="button_83.block"
              [disabled]="button_83.disabled"
              [key]="button_83.key"
              [emitWithoutPopconfirm]="button_83.emitWithoutPopconfirm"
              [popconfirmTitle]="button_83.popconfirmTitle"
              [borderSettings]="button_83.borderSettings"
              [marginSettings]="button_83.marginSettings"
              [paddingSettings]="button_83.paddingSettings"
              [shadowSettings]="button_83.shadowSettings"
              [customColorSettings]="button_83.customColorSettings"
              [customSizeSettings]="button_83.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 84 -->
            <rappider-button
              [text]="button_84.text"
              [type]="button_84.type"
              [shape]="button_84.shape"
              [size]="button_84.size"
              [colorType]="button_84.colorType"
              [icon]="button_84.icon"
              [iconPlacement]="button_84.iconPlacement"
              [transparent]="button_84.transparent"
              [loading]="button_84.loading"
              [block]="button_84.block"
              [disabled]="button_84.disabled"
              [key]="button_84.key"
              [emitWithoutPopconfirm]="button_84.emitWithoutPopconfirm"
              [popconfirmTitle]="button_84.popconfirmTitle"
              [borderSettings]="button_84.borderSettings"
              [marginSettings]="button_84.marginSettings"
              [paddingSettings]="button_84.paddingSettings"
              [shadowSettings]="button_84.shadowSettings"
              [customColorSettings]="button_84.customColorSettings"
              [customSizeSettings]="button_84.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 85 -->
            <rappider-button
              [text]="button_85.text"
              [type]="button_85.type"
              [shape]="button_85.shape"
              [size]="button_85.size"
              [colorType]="button_85.colorType"
              [icon]="button_85.icon"
              [iconPlacement]="button_85.iconPlacement"
              [transparent]="button_85.transparent"
              [loading]="button_85.loading"
              [block]="button_85.block"
              [disabled]="button_85.disabled"
              [key]="button_85.key"
              [emitWithoutPopconfirm]="button_85.emitWithoutPopconfirm"
              [popconfirmTitle]="button_85.popconfirmTitle"
              [borderSettings]="button_85.borderSettings"
              [marginSettings]="button_85.marginSettings"
              [paddingSettings]="button_85.paddingSettings"
              [shadowSettings]="button_85.shadowSettings"
              [customColorSettings]="button_85.customColorSettings"
              [customSizeSettings]="button_85.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 86 -->
            <rappider-button
              [text]="button_86.text"
              [type]="button_86.type"
              [shape]="button_86.shape"
              [size]="button_86.size"
              [colorType]="button_86.colorType"
              [icon]="button_86.icon"
              [iconPlacement]="button_86.iconPlacement"
              [transparent]="button_86.transparent"
              [loading]="button_86.loading"
              [block]="button_86.block"
              [disabled]="button_86.disabled"
              [key]="button_86.key"
              [emitWithoutPopconfirm]="button_86.emitWithoutPopconfirm"
              [popconfirmTitle]="button_86.popconfirmTitle"
              [borderSettings]="button_86.borderSettings"
              [marginSettings]="button_86.marginSettings"
              [paddingSettings]="button_86.paddingSettings"
              [shadowSettings]="button_86.shadowSettings"
              [customColorSettings]="button_86.customColorSettings"
              [customSizeSettings]="button_86.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 44 -->
      <div
        class="rappider-container container-44 col-12 container-spacing-settings"
      >
        <!-- Container: Container 45 -->
        <div class="rappider-container container-45 container-spacing-settings">
          <div class="rappider-component">
            <!-- Component: Text 87 -->
            <rappider-text
              [textMode]="text_87.textMode"
              [text]="text_87.text"
              [content]="text_87.content"
              [typography]="text_87.typography"
              [colorSettings]="text_87.colorSettings"
            >
            </rappider-text>
          </div>
        </div>

        <!-- Container: Container 46 -->
        <div
          class="rappider-container container-46 col-7 container-spacing-settings container-width-100-mw480"
        >
          <div class="rappider-component">
            <!-- Component: Button 88 -->
            <rappider-button
              [text]="button_88.text"
              [type]="button_88.type"
              [shape]="button_88.shape"
              [size]="button_88.size"
              [colorType]="button_88.colorType"
              [icon]="button_88.icon"
              [iconPlacement]="button_88.iconPlacement"
              [transparent]="button_88.transparent"
              [loading]="button_88.loading"
              [block]="button_88.block"
              [disabled]="button_88.disabled"
              [key]="button_88.key"
              [emitWithoutPopconfirm]="button_88.emitWithoutPopconfirm"
              [popconfirmTitle]="button_88.popconfirmTitle"
              [borderSettings]="button_88.borderSettings"
              [marginSettings]="button_88.marginSettings"
              [paddingSettings]="button_88.paddingSettings"
              [shadowSettings]="button_88.shadowSettings"
              [customColorSettings]="button_88.customColorSettings"
              [customSizeSettings]="button_88.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 89 -->
            <rappider-button
              [text]="button_89.text"
              [type]="button_89.type"
              [shape]="button_89.shape"
              [size]="button_89.size"
              [colorType]="button_89.colorType"
              [icon]="button_89.icon"
              [iconPlacement]="button_89.iconPlacement"
              [transparent]="button_89.transparent"
              [loading]="button_89.loading"
              [block]="button_89.block"
              [disabled]="button_89.disabled"
              [key]="button_89.key"
              [emitWithoutPopconfirm]="button_89.emitWithoutPopconfirm"
              [popconfirmTitle]="button_89.popconfirmTitle"
              [borderSettings]="button_89.borderSettings"
              [marginSettings]="button_89.marginSettings"
              [paddingSettings]="button_89.paddingSettings"
              [shadowSettings]="button_89.shadowSettings"
              [customColorSettings]="button_89.customColorSettings"
              [customSizeSettings]="button_89.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 90 -->
            <rappider-button
              [text]="button_90.text"
              [type]="button_90.type"
              [shape]="button_90.shape"
              [size]="button_90.size"
              [colorType]="button_90.colorType"
              [icon]="button_90.icon"
              [iconPlacement]="button_90.iconPlacement"
              [transparent]="button_90.transparent"
              [loading]="button_90.loading"
              [block]="button_90.block"
              [disabled]="button_90.disabled"
              [key]="button_90.key"
              [emitWithoutPopconfirm]="button_90.emitWithoutPopconfirm"
              [popconfirmTitle]="button_90.popconfirmTitle"
              [borderSettings]="button_90.borderSettings"
              [marginSettings]="button_90.marginSettings"
              [paddingSettings]="button_90.paddingSettings"
              [shadowSettings]="button_90.shadowSettings"
              [customColorSettings]="button_90.customColorSettings"
              [customSizeSettings]="button_90.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 91 -->
            <rappider-button
              [text]="button_91.text"
              [type]="button_91.type"
              [shape]="button_91.shape"
              [size]="button_91.size"
              [colorType]="button_91.colorType"
              [icon]="button_91.icon"
              [iconPlacement]="button_91.iconPlacement"
              [transparent]="button_91.transparent"
              [loading]="button_91.loading"
              [block]="button_91.block"
              [disabled]="button_91.disabled"
              [key]="button_91.key"
              [emitWithoutPopconfirm]="button_91.emitWithoutPopconfirm"
              [popconfirmTitle]="button_91.popconfirmTitle"
              [borderSettings]="button_91.borderSettings"
              [marginSettings]="button_91.marginSettings"
              [paddingSettings]="button_91.paddingSettings"
              [shadowSettings]="button_91.shadowSettings"
              [customColorSettings]="button_91.customColorSettings"
              [customSizeSettings]="button_91.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 92 -->
            <rappider-button
              [text]="button_92.text"
              [type]="button_92.type"
              [shape]="button_92.shape"
              [size]="button_92.size"
              [colorType]="button_92.colorType"
              [icon]="button_92.icon"
              [iconPlacement]="button_92.iconPlacement"
              [transparent]="button_92.transparent"
              [loading]="button_92.loading"
              [block]="button_92.block"
              [disabled]="button_92.disabled"
              [key]="button_92.key"
              [emitWithoutPopconfirm]="button_92.emitWithoutPopconfirm"
              [popconfirmTitle]="button_92.popconfirmTitle"
              [borderSettings]="button_92.borderSettings"
              [marginSettings]="button_92.marginSettings"
              [paddingSettings]="button_92.paddingSettings"
              [shadowSettings]="button_92.shadowSettings"
              [customColorSettings]="button_92.customColorSettings"
              [customSizeSettings]="button_92.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 93 -->
            <rappider-button
              [text]="button_93.text"
              [type]="button_93.type"
              [shape]="button_93.shape"
              [size]="button_93.size"
              [colorType]="button_93.colorType"
              [icon]="button_93.icon"
              [iconPlacement]="button_93.iconPlacement"
              [transparent]="button_93.transparent"
              [loading]="button_93.loading"
              [block]="button_93.block"
              [disabled]="button_93.disabled"
              [key]="button_93.key"
              [emitWithoutPopconfirm]="button_93.emitWithoutPopconfirm"
              [popconfirmTitle]="button_93.popconfirmTitle"
              [borderSettings]="button_93.borderSettings"
              [marginSettings]="button_93.marginSettings"
              [paddingSettings]="button_93.paddingSettings"
              [shadowSettings]="button_93.shadowSettings"
              [customColorSettings]="button_93.customColorSettings"
              [customSizeSettings]="button_93.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 94 -->
            <rappider-button
              [text]="button_94.text"
              [type]="button_94.type"
              [shape]="button_94.shape"
              [size]="button_94.size"
              [colorType]="button_94.colorType"
              [icon]="button_94.icon"
              [iconPlacement]="button_94.iconPlacement"
              [transparent]="button_94.transparent"
              [loading]="button_94.loading"
              [block]="button_94.block"
              [disabled]="button_94.disabled"
              [key]="button_94.key"
              [emitWithoutPopconfirm]="button_94.emitWithoutPopconfirm"
              [popconfirmTitle]="button_94.popconfirmTitle"
              [borderSettings]="button_94.borderSettings"
              [marginSettings]="button_94.marginSettings"
              [paddingSettings]="button_94.paddingSettings"
              [shadowSettings]="button_94.shadowSettings"
              [customColorSettings]="button_94.customColorSettings"
              [customSizeSettings]="button_94.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 95 -->
            <rappider-button
              [text]="button_95.text"
              [type]="button_95.type"
              [shape]="button_95.shape"
              [size]="button_95.size"
              [colorType]="button_95.colorType"
              [icon]="button_95.icon"
              [iconPlacement]="button_95.iconPlacement"
              [transparent]="button_95.transparent"
              [loading]="button_95.loading"
              [block]="button_95.block"
              [disabled]="button_95.disabled"
              [key]="button_95.key"
              [emitWithoutPopconfirm]="button_95.emitWithoutPopconfirm"
              [popconfirmTitle]="button_95.popconfirmTitle"
              [borderSettings]="button_95.borderSettings"
              [marginSettings]="button_95.marginSettings"
              [paddingSettings]="button_95.paddingSettings"
              [shadowSettings]="button_95.shadowSettings"
              [customColorSettings]="button_95.customColorSettings"
              [customSizeSettings]="button_95.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Container: Container 47 -->
    <div class="rappider-container container-47 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 96 -->
        <rappider-divider
          [style]="divider_96.style"
          [type]="divider_96.type"
          [text]="divider_96.text"
          [textPlacement]="divider_96.textPlacement"
          [dividerWidth]="divider_96.dividerWidth"
          [dividerColor]="divider_96.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 48 -->
    <div class="rappider-container container-48 col-12">
      <!-- Container: Container 49 -->
      <div class="rappider-container container-49 col-6">
        <div class="rappider-component">
          <!-- Component: Text 97 -->
          <rappider-text
            [textMode]="text_97.textMode"
            [text]="text_97.text"
            [content]="text_97.content"
            [typography]="text_97.typography"
            [colorSettings]="text_97.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 50 -->
      <div class="rappider-container container-50 col-6">
        <div class="rappider-component">
          <!-- Component: Text 98 -->
          <rappider-text
            [textMode]="text_98.textMode"
            [text]="text_98.text"
            [content]="text_98.content"
            [typography]="text_98.typography"
            [colorSettings]="text_98.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 99 -->
          <rappider-image
            [source]="image_99.source"
            [alternateText]="image_99.alternateText"
            [placeholder]="image_99.placeholder"
            [disablePreview]="image_99.disablePreview"
            [borderSettings]="image_99.borderSettings"
            [shadowSettings]="image_99.shadowSettings"
            [paddingSettings]="image_99.paddingSettings"
            [marginSettings]="image_99.marginSettings"
            [customSizeSettings]="image_99.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 100 -->
          <rappider-image
            [source]="image_100.source"
            [alternateText]="image_100.alternateText"
            [placeholder]="image_100.placeholder"
            [disablePreview]="image_100.disablePreview"
            [borderSettings]="image_100.borderSettings"
            [shadowSettings]="image_100.shadowSettings"
            [paddingSettings]="image_100.paddingSettings"
            [marginSettings]="image_100.marginSettings"
            [customSizeSettings]="image_100.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 101 -->
          <rappider-image
            [source]="image_101.source"
            [alternateText]="image_101.alternateText"
            [placeholder]="image_101.placeholder"
            [disablePreview]="image_101.disablePreview"
            [borderSettings]="image_101.borderSettings"
            [shadowSettings]="image_101.shadowSettings"
            [paddingSettings]="image_101.paddingSettings"
            [marginSettings]="image_101.marginSettings"
            [customSizeSettings]="image_101.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 102 -->
          <rappider-image
            [source]="image_102.source"
            [alternateText]="image_102.alternateText"
            [placeholder]="image_102.placeholder"
            [disablePreview]="image_102.disablePreview"
            [borderSettings]="image_102.borderSettings"
            [shadowSettings]="image_102.shadowSettings"
            [paddingSettings]="image_102.paddingSettings"
            [marginSettings]="image_102.marginSettings"
            [customSizeSettings]="image_102.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 103 -->
          <rappider-image
            [source]="image_103.source"
            [alternateText]="image_103.alternateText"
            [placeholder]="image_103.placeholder"
            [disablePreview]="image_103.disablePreview"
            [borderSettings]="image_103.borderSettings"
            [shadowSettings]="image_103.shadowSettings"
            [paddingSettings]="image_103.paddingSettings"
            [marginSettings]="image_103.marginSettings"
            [customSizeSettings]="image_103.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
